import React, { useState } from 'react';
import './App.css';
import { AggregatorAbi, TChainName, TComputeStepParams, TContractCallParams, TParsedContractCallParams, supportedChains } from '../../types';
import { emptyCallParam, emptyOperation, emptyParsedParams } from '../../types/constants';
import Menu from '../Menu/Menu';
import CallParam from '../CallParams/CallParams';
import Ops from "../Operations/Ops";
import { useEncodeOperations, useEncodeCalls, useMulticall } from '../../hooks';
import { decodeSignedInteger } from '../../utils';

function App() {

  const [rawCallParams, setRawCallParams] = useState<TContractCallParams[]>([emptyCallParam]);
  const [parsedCallParams, setParsedCallParams] = useState<TParsedContractCallParams[]>([emptyParsedParams]);
  const [rawOperations, setRawOperations] = useState<TComputeStepParams[]>([emptyOperation]);
  const [chainName, setChainName] = useState<TChainName>('ethereum');
  const [helperAddress, setHelperAddress] = useState<string>(supportedChains[chainName].gcr);

  const { encodedOperations, errorOps, encodeOps } = useEncodeOperations(chainName, rawOperations);
  const { encodedCalls, callsError, encodeCalls } = useEncodeCalls(chainName, parsedCallParams);
  const multicallResults = useMulticall(chainName, encodedCalls, encodedOperations);

  const onAddCallParamsClick = () => {
    setRawCallParams([...rawCallParams, emptyCallParam]);
  }

  const onAddOperationsClick = () => {
    setRawOperations([...rawOperations, emptyOperation]);
  }

  const onEncodeParamsClick = () => {
    encodeOps();
    encodeCalls();
  }

  const onContractCallClick = () => {
    multicallResults. multicall();
  }

  const removeCallParam = (index: number) => {
    const updatedSteps = rawCallParams.filter((
      item: TContractCallParams, i: number
    ) => i != index);
    setRawCallParams(updatedSteps);
  }

  const removeStep = (index: number) => {
    const updatedSteps = rawOperations.filter((
      item: TComputeStepParams, i: number
    ) => i != index);
    setRawOperations(updatedSteps);
  }

  const updateRawCallParams = (index: number, item: TContractCallParams, parsed: TParsedContractCallParams) => {
    let updated: TContractCallParams[] = rawCallParams;
    updated[index] = item;
    setRawCallParams(updated);

    let updatedParsed: TParsedContractCallParams[] = parsedCallParams;
    parsedCallParams[index] = parsed;
    setParsedCallParams(parsedCallParams);
  }

  const updateRawOperations = (index: number, item: TComputeStepParams) => {
    let updated: TComputeStepParams[] = rawOperations;
    updated[index] = item;
    setRawOperations(updated);
  }

  const onChainSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const chain: TChainName = e.target.value;
    setChainName(chain);
    setHelperAddress(supportedChains[chain].gcr);
  }

  return (
    <div className="App">
      <div className='appRow'>
        <div className='percent20'>
          <Menu
            onAddCallParamsClick={onAddCallParamsClick}
            onAddOperationsClick={onAddOperationsClick}
            onEncodeParamsClick={onEncodeParamsClick}
            onContractCallClick={onContractCallClick}
            onChainSelect={onChainSelect}
            helper={helperAddress}
          />
        </div>
        <div className='percent40'>
          <div className='center'>
            <h3>Raw Contract Call Parameters</h3>
            {rawCallParams && rawCallParams.map((param: TContractCallParams, index: number) => (
              <CallParam
                chainName={chainName}
                index={index}
                key={index}
                onChange={updateRawCallParams}
                removeParam={removeCallParam}
                value={param}
              />
            ))}
          </div>
        </div>
        <div className='percent40'>
          <div className='center'>
            <h3>Raw Operations</h3>
            {rawOperations && rawOperations.map((op: TComputeStepParams, index: number) => (
              <Ops
                key={index}
                index={index}
                onChange={updateRawOperations}
                removeOperation={removeStep}
                values={op}
              />
            ))}
          </div>
        </div>
      </div>
      <div className='appRow'>
        <div className='percent20'>
          <div className=''>
            <h3>Call result</h3>
            <textarea
              rows={2}
              value={multicallResults.result}
            ></textarea>
            <textarea
              rows={15}
              value={JSON.stringify(AggregatorAbi)}
            >

            </textarea>
          </div>
        </div>
        <div className='percent40'>
          <div className='center'>
            <h3>requestData</h3>
            <textarea
              readOnly
              rows={20}
              value={encodedCalls}
            >

            </textarea>
          </div>
        </div>
        <div className='percent40'>
          <div className='center'>
            <h3>orderData</h3>
            <textarea
              readOnly
              rows={20}
              value={encodedOperations}
            >

            </textarea>
          </div>
        </div>
      </div>

    </div>
  );
}

export default App;
